import { render } from "./recentActivity.vue?vue&type=template&id=4d01b502"
import script from "./recentActivity.vue?vue&type=script&lang=js"
export * from "./recentActivity.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__